export const getBingSearchPlacementBaseStyles = () => ({
  placementCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    position: 'relative',
    boxSizing: 'content-box',
    overflow: 'hidden',
    background: '#fff',
    margin: 'auto',

    '& .placement-card-content': {
      width: '100%',
      height: '100%',
    },
  },
  placementTextContainer: {
    margin: '4px 8px 0 8px',
    fontSize: 10,
    lineHeight: '16px',
    color: '#0078d4',
    cursor: 'pointer',
    overflow: 'hidden',
    '&:hover': {
      color: '#004578',
    },

    '& .logo-and-text-container': {
      display: 'flex',
      flexDirection: 'row',
      paddingBottom: 8,
      '& .logo-text': {
        display: 'flex',
        flexDirection: 'column',
      },
    },
  },
  placementLongHeadline: {
    height: 28,
    fontSize: 20,
    fontWeight: 400,
    lineHeight: '24px',
    overflow: 'hidden',
    width: '100%',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  placementFinalUrl: {
    height: 20,
    fontSize: 14,
    color: '#0b6a0b',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  placementDescriptionContainer: {
    display: 'flex',
  },
  placementAdsLabel: {
    position: 'static !important',
    color: '#767676 !important',
    border: '1px solid #ddd !important',
    margin: '0 4px 0 0 !important',
    display: 'inline',
    opacity: '100% !important',
    padding: '0 2px !important',
    maxHeight: 16,
    fontWeight: 600,
    lineHeight: 1,
    borderRadius: '6px !important',
  },
  placementDescription: {
    color: '#333',
    display: 'inline-block',
    fontSize: 13,
    flexGrow: 1,
  },
});


export const getBingSearchTextPlacementStyles = (theme: object) => {
  const { placementCard, placementTextContainer, ...baseStyles } = getBingSearchPlacementBaseStyles();
  const styles = {
    ...baseStyles,

    placementCard: {
      ...placementCard,
      width: 608,
      minHeight: 110,
      padding: '8px 16px',
      alignItems: 'flex-start',
    },
    placementTextContainer: {
      ...placementTextContainer,
      '& .logo-and-text-container .logo-text .logo-business-name': {
        color: '#666',
        fontSize: 14,
        fontWeight: 400,
        lineHeight: '22px',
      },
    },
    placementLogoContainer: {
      paddingRight: 8,
      '& .cropped-image-view': {
        borderRadius: 6,
      },
    },
  };
  return styles;
};


export const getBingSearchTextDesktopPlacementStyles = (theme: object) => {
  const { placementCard, ...baseStyles } = getBingSearchPlacementBaseStyles();
  const styles = {
    ...baseStyles,

    placementCard: {
      ...placementCard,
      display: 'block',
      width: 530,
      height: 110,
      top: 0,
      padding: '8px 16px',
      boxShadow: 'none',
      // border: none;
      // border-radius: 5.11px;
    },
    bingSearchDesktopPlacementRoot: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      '& .header-image': {
        position: 'relative',
        left: -16,
        height: 100,
        '& img': {
          verticalAlign: 'middle',
        },
      },
    },
  };
  return styles;
};


export const getBingSearchTextMobilePlacementStyles = (theme: object) => {
  const { placementCard, ...baseStyles } = getBingSearchPlacementBaseStyles();
  const styles = {
    ...baseStyles,

    placementCard: {
      ...placementCard,
      display: 'block',
      width: 608,
      border: '0.5px solid #ddd',
      height: 110,
      padding: '8px 16px',
      boxShadow: '0px 0.511px 1.533px rgb(0 0 0 / 10%), 0px 2.72533px 6.132px rgb(0 0 0 / 13%)',
      borderRadius: 5.11,
    },
    bingSearchMobilePlacementRoot: {
      display: 'flex',
      flexGrow: 1,
      flexDirection: 'column',
      alignItems: 'center',
      position: 'relative',
      width: 700,
      opacity: '100%',
      border: '5px solid #605e5c',
      borderRadius: '40px 40px 0 0',
      borderBottom: 'none',
      '& .bing-search-mobile-placement-parent': {
        margin: '45px 15px 0 15px',
        borderBottom: 'none',
        borderRadius: 0,
        paddingBottom: 1,

        '&:before': {
          position: 'absolute',
          top: 20,
          left: '50%',
          border: '5px solid #605e5c',
          content: '""',
          borderRadius: 5,
        },
      },
    },
  };
  return styles;
};
